'use strict';

import React, { Component } from 'react'

/* globals google */

const { app } = window;

export default class GMap extends Component
{
	state =
	{
		gmap_id: ++app.gmap_id
	};

	map = undefined;

	componentDidMount ()
	{
		const component = this, props = this.props;

		try
		{
			component.startMapIfNeeded();
		}
		catch (e)
		{
			console.error(e);
		}
	}

	componentDidUpdate ()
	{
		const component = this, props = this.props;

		try
		{
			component.startMapIfNeeded();
		}
		catch (e)
		{
			console.error(e);
		}
	}

	getStringFromAddress = (data) =>
	{
		let address = '';

		if (data.name && data.name !== data.line_1) address += data.name + ', ';

		if (data.line_1) address += data.line_1;

		if (data.zip_code) address += ', ' + data.zip_code;

		if (!data.zip_code) address += ', ';

		if (data.city) address += data.city;

		return address || 'France';
	}

	updateMap = (place_id) =>
	{
		const component = this, props = this.props;

		var geocoder = new google.maps.Geocoder();

		let address = props.address;

		let request_data = { };

		if (place_id)
		{
			request_data.placeId = place_id;
		}
		else
		{
			request_data.address = address ? component.getStringFromAddress(address) : 'France';
		}

		geocoder.geocode(request_data,
		function (results, status)
		{
			if (status === 'OK')
			{
				component.map.setCenter(results[0].geometry.location);
				component.map.setZoom(13);

				var marker = new google.maps.Marker(
				{
					position: results[0].geometry.location,
					map: component.map,
					title: props.address.label
				});

				marker.setMap(component.map);
			}
			else if (status === 'ZERO_RESULTS' && !place_id)
			{
				component.searchAddress(request_data.address);
			}
			else
			{
				console.error('Gmap error', status);
			}
		});
	}

	searchAddress = (address) =>
	{
		const component = this, props = this.props;

		let service = new google.maps.places.PlacesService(component.map);

		service.textSearch(
		{
			query: address
		},
		function (results, status)
		{
			if (status === google.maps.places.PlacesServiceStatus.OK)
			{
				let place = results[0];

				if (place)
				{
					component.updateMap(results[0].place_id);
				}
			}
		});
	}

	startMapIfNeeded = () =>
	{
		const component = this, props = this.props;

		if (component.map) return;

		let map_div = document.getElementById('gmap-' + component.state.gmap_id);

		const default_pos = props.pins?.length === 1
		? props.pins[0].position || { }
		: undefined;

		component.map = new google.maps.Map(map_div,
		{
			zoom: default_pos ? 12 : 8,
			center:
			{
				lat: default_pos?.lat !== undefined ? default_pos.lat : 43.5029078,
				lng: default_pos?.lng !== undefined ? default_pos.lng : -1.4928724
			}
		});

		var geocoder = new google.maps.Geocoder();

		let address = props.address;

		if ((props.pins || [])[0])
		{
			return props.pins.forEach(function (infos)
			{
				var marker = new google.maps.Marker(
				{
					position: infos.position,
					map: component.map,
					title: infos.name
				});

				marker.setMap(component.map);
			});
		}

		geocoder.geocode(
		{
			'address': address ? component.getStringFromAddress(address) : 'France'
		},
		function (results, status)
		{
			if (status === 'OK')
			{
				var marker = new google.maps.Marker(
				{
					position: results[0].geometry.location,
					map: component.map,
					title: props.address.label
				});

				marker.setMap(component.map);
			}
			else if (status === 'ZERO_RESULTS')
			{
				component.searchAddress(component.getStringFromAddress(address));
			}
			else
			{
				console.error('Gmap error', status);
			}
		});
	}

	render ()
	{
		const component = this, props = this.props;

		var output =
		(
			<div className={ props.className || 'c-gmap' }
				id={ 'gmap-' + component.state.gmap_id }
			/>
		);

		return output;
	}
}
